import { useMutation } from 'react-query';
import request from '../../../../helpers/request';
import { fieldNames } from '../../shared/configs/acceptanceForm';

const mutationFn = (data) => {
  const {
    [fieldNames.main.fromDate]: newFromDate,
    [fieldNames.main.toDate]: newToDate,
    ...other
  } = data;

  return request.post(
    'Acceptance/change_dates_and_add_new_graph',
    other,
    'Не удалось создать новую кофигурацию',
    'Error',
    undefined,
    { newFromDate, newToDate }
  );
};

export const useCreateNewConfigMutation = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
